<template>
    <div class="alert-system">
        <transition-group name="alert" tag="div" class="alert-container">
            <div v-for="alert in alerts" :key="alert.id"
                :class="['alert', `alert-${alert.type}`, 'alert-dismissible', 'fade', 'show']" role="alert">
                <i :class="getAlertIcon(alert.type)"></i>
                <span v-html="alert.message"></span>
                <button type="button" class="btn-close" @click="removeAlert(alert.id)" aria-label="Close"></button>
            </div>
        </transition-group>
    </div>
</template>

<script>
    export default {
        name: "AlertSystem",
        data() {
            return {
                alerts: [],
                nextId: 1
            };
        },
        methods: {
            showAlert(message, type = "info", duration = 5000) {
                const alert = {
                    id: this.nextId++,
                    message,
                    type,
                    timestamp: Date.now()
                };

                this.alerts.push(alert);

                if (duration > 0) {
                    setTimeout(() => {
                        this.removeAlert(alert.id);
                    }, duration);
                }
            },

            removeAlert(id) {
                const index = this.alerts.findIndex(alert => alert.id === id);
                if (index > -1) {
                    this.alerts.splice(index, 1);
                }
            },

            getAlertIcon(type) {
                const icons = {
                    success: "bi bi-check-circle-fill",
                    error: "bi bi-exclamation-triangle-fill",
                    warning: "bi bi-exclamation-circle-fill",
                    info: "bi bi-info-circle-fill"
                };
                return icons[type] || icons.info;
            }
        }
    };
</script>

<style scoped>
    .alert-system {
        position: fixed;
        top: 20px;
        right: 20px;
        z-index: 9999;
        max-width: 400px;
    }

    .alert-container {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .alert {
        margin-bottom: 0;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        border: none;
        border-radius: 8px;
        padding: 12px 16px;
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .alert i {
        font-size: 1.1rem;
    }

    .alert-success {
        background-color: #d1e7dd;
        color: #0f5132;
        border-left: 4px solid #198754;
    }

    .alert-error {
        background-color: #f8d7da;
        color: #721c24;
        border-left: 4px solid #dc3545;
    }

    .alert-warning {
        background-color: #fff3cd;
        color: #856404;
        border-left: 4px solid #ffc107;
    }

    .alert-info {
        background-color: #d1ecf1;
        color: #0c5460;
        border-left: 4px solid #0dcaf0;
    }

    .btn-close {
        margin-left: auto;
        background: none;
        border: none;
        font-size: 1.2rem;
        opacity: 0.7;
        cursor: pointer;
    }

    .btn-close:hover {
        opacity: 1;
    }

    /* Animations */
    .alert-enter-active,
    .alert-leave-active {
        transition: all 0.3s ease;
    }

    .alert-enter-from {
        opacity: 0;
        transform: translateX(100%);
    }

    .alert-leave-to {
        opacity: 0;
        transform: translateX(100%);
    }

    .alert-move {
        transition: transform 0.3s ease;
    }

    @media (max-width: 768px) {
        .alert-system {
            left: 20px;
            right: 20px;
            max-width: none;
        }
    }
</style>